<template>
  <AppHeader>All Customers</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex items-center mb-3 bg-white shadow justify-evenly rounded-2xl text-slate-500">
      <router-link class="py-2 text-lg" :to="{name: 'CustomersSort'}">Sort Order</router-link>
      <p class="text-gray-400">|</p>
      <router-link class="py-2 text-lg" :to="{name: 'CustomersPotentialDropout'}">Potential Dropout</router-link>
      <p class="text-gray-400">|</p>
      <router-link class="py-2 text-lg" :to="{name: 'CustomersLowBalance'}">Low Balance</router-link>
    </div>

    <SearchSort
      ref="search"
      :defaults="{q: '', search: '-', sort: 'dealer_order', order: 'asc', group: '-', tag: '-'}"
      :sorts="{id: 'ID', name: 'Name', address: 'Address', wallet_balance: 'Wallet', dealer_order: 'Customer Sort', subscriptions_count: 'Active Subscriptions', 'group.name': 'Group Name', 'group.sort_no': 'Group Order'}"
      :columns="{id: 'ID', name: 'Name', address: 'Address'}"
      :groups="groups"
      :tags="tags"
      @update="searchUpdated">
    </SearchSort>

    <div class="mt-5 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Tags</th>
            <th>Phone</th>
            <th>Wallet</th>
            <th>Active Subs.</th>
            <th>Group</th>
            <th>Address</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="customer in customersFiltered" :key="customer.id" :class="{'bg-red-200': customer.wallet_balance < 100}">
            <td>#{{ customer.id }}</td>
            <td><router-link :to="{name: 'ViewCustomer', params: {id: customer.id}}"><b>{{ customer.name }}</b></router-link></td>
            <td><small>{{ customer.tags ? customer.tags.join(', ') : '' }}</small></td>
            <td align="center"><a @click="initiateCall(customer.phone)" class="px-2"><i class="ion-md-call"></i></a></td>
            <td>{{ toInr(customer.wallet_balance) }}</td>
            <td>{{ customer.subscriptions_count }}</td>
            <td>{{ customer.group.name }}</td>
            <td class="text-sm">{{ customer.address }}</td>
            <td>
              <router-link class="px-2 mr-1 text-xs leading-none rounded-full bg-slate-300" :to="{name: 'CreateTransaction', query: {customer_id: customer.id}}"><i class="ion-md-add"></i> TNX</router-link>
              <router-link class="px-2 mr-1 text-xs leading-none rounded-full bg-slate-300" :to="{name: 'CreateSubscription', query: {customer_id: customer.id}}"><i class="ion-md-add"></i> SUB</router-link>
              <router-link class="px-2 mr-1 text-xs leading-none rounded-full bg-slate-300" :to="{name: 'CreateVacation', query: {customer_id: customer.id}}"><i class="ion-md-add"></i> VAC</router-link>
              <router-link class="px-2 mr-1 text-xs leading-none bg-green-300 rounded-full" :to="{name: 'CustomerMapLocation', params: {id: customer.id}}"><i class="ion-md-pin"></i> MAP</router-link>
              <a v-if="customer.house_image" class="px-2 mr-1 text-xs leading-none bg-blue-300 rounded-full" :href="customer.house_image.src" target="_system"><i class="icon ion-md-image"></i> HOUSE</a>
              <router-link class="px-2 mr-1 text-xs leading-none rounded-full bg-slate-300" :to="{name: 'BottleExchangeCreate', params: {id: customer.id}, query: {type: 'customer', name: customer.name}}"><i class="icon ion-md-add"></i> BOTTLE</router-link>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import SearchSort from '@/components/common/SearchSort.vue';

export default {
  name: 'Customers',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading, SearchSort },
  data() {
    return {
      state: 'loading',
      showInactive: false,
      customers: [],
      customersFiltered: [],
      groups: [],
      tags: [],
    }
  },

  methods: {
    searchUpdated(q, search, sort, order, group, tag) {
      if (!q ||q == null || q.length == 0) this.customersFiltered = this.customers;

      if (search == '-') this.customersFiltered = this.customers.filter((item) => JSON.stringify(item).toLowerCase().includes(q.toLowerCase()));
      else this.customersFiltered = this.customers.filter((item) => JSON.stringify(this.getDeepValue(item, search)).toLowerCase().includes(q.toLowerCase()));

      if (group != '-') this.customersFiltered = this.customersFiltered.filter((item) => item.group_id == group);

      if (tag != '-') this.customersFiltered = this.customersFiltered.filter((item) => item.tags != null ? item.tags.includes(tag) : false);

      this.customersFiltered.sort((a, b) => {
        let aData = this.getDeepValue(a, sort), bData = this.getDeepValue(b, sort);
        return (aData == bData ? 0 : aData < bData ? -1 : 1) * (order == 'desc' ? -1 : 1);
      });
    },

    toggleInactiveCustomer() {
      this.showInactive = !this.showInactive;
    },

    getData() {
      this.state = 'loading';

      this.request('GET', 'customers', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.customers = resp.data.customers;
          this.groups = resp.data.groups;
          this.tags = resp.data.tags;
          this.customersFiltered = resp.data.customers;
          this.$nextTick(() => {
            this.$refs.search._emit();
          });
        }
      });
    },
  },

  created() {
    if (!this.$store.state.user.id) this.$router.push('/dash');
    else this.getData();
  }
}
</script>
